<!--
 * @Author: DYM
 * @Date: 2020-03-16 14:36:50
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 11:41:34
 * @Description: 用户管理（单身份）
 -->
<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <!-- 页面头部 Start -->
    <div class="l-page__header c-page__header">
      <!-- 右侧标题 -->
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        用户信息
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div class="c-page__header-btns">
        <k-button
          btn-text="查询"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch()"
        />
        <k-button
          btn-text="重置"
          :auth-type="false"
          icon="kestrel-icon ki-repeat"
          @click="resetForm"
        />
        <k-button
          btn-text="新增"
          :auth-type="true"
          type="success"
          icon="kestrel-icon ki-plus"
          @click="handleAddUser()"
        />
        <k-button
          btn-text="同步操作员至省平台"
          :auth-type="true"
          type="success"
          icon="kestrel-icon ki-yonghu1"
          @click="handleBindGdshpt()"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 查询条件 Start -->
    <div class="l-page__item l-page--search__item">
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <!-- 查询条件表单 Start -->
        <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          label-position="right"
          label-width="80px"
          label-suffix="："
        >
          <el-row class="c-form__row">
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="姓名"
                prop="userName"
              >
                <el-input
                  v-model.trim="filterParams.userName"
                  class="c-form__input"
                  placeholder="姓名"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="联系电话"
                prop="userCode"
              >
                <el-input
                  v-model.trim="filterParams.userCode"
                  class="c-form__input"
                  placeholder="联系电话"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询条件表单 End -->
      </hm-page-card>
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div class="l-page__body l-page--search__body">
      <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane label="用户列表">
          <div class="c-page__pTable">
            <!-- table的ref的命名根据业务名称修改 -->
            <el-table
              ref="attrUserTable"
              class="c-page__table o-header-text-center"
              height="100%"
              stripe
              border
              highlight-current-row
              tooltip-effect="dark"
              :data="page.rows"
              :class="{ 'o-table-empty-center': page.rows.length <= 0 }"
            >
              <el-table-column
                type="index"
                label="序号"
                width="40"
                align="center"
              />
              <!-- <el-table-column
                prop="userCode"
                label="用户编码"
                width="120"
                show-overflow-tooltip
              /> -->
              <el-table-column
                prop="userName"
                label="姓名"
                width="120"
                show-overflow-tooltip
              />
              <el-table-column
                prop="tel"
                label="联系电话"
                min-width="120"
                show-overflow-tooltip
              />
              <!-- <el-table-column
                prop="SFTSSPT"
                label="关联省平台"
                min-width="120"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span :class="scope.row.SFTSSPT === 'Y' ? 'u-text-success' : 'u-text-info'">
                    {{ scope.row.SFTSSPT === 'Y' ? '已关联' : '未关联' }}
                  </span>
                </template>
              </el-table-column> -->
              <template v-for="(attrUserItem, index) in attrUserList">
                <template v-if="attrUserItem.attrType==='Date'">
                  <el-table-column
                    :key="'attrUser'+ index"
                    :prop="attrUserItem.attrKey"
                    :label="attrUserItem.attrName"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      {{ scope.row[attrUserItem.attrKey] | date('yyyy-MM-dd') }}
                    </template>
                  </el-table-column>
                </template>
                <template v-else-if="attrUserItem.enums">
                  <el-table-column
                    :key="'attrUser'+ index"
                    :prop="attrUserItem.attrKey"
                    :label="attrUserItem.attrName"
                    :min-width="attrUserItem.attrName.length > 3 ? attrUserItem.attrName.length * 24 : 90"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      {{ scope.row[attrUserItem.attrKey+'_NAME'] }}
                    </template>
                  </el-table-column>
                </template>
                <template v-else-if="attrUserItem.attrType!='Image'">
                  <el-table-column
                    :key="'attrUser'+ index"
                    :prop="attrUserItem.attrKey"
                    :label="attrUserItem.attrName"
                    :min-width="attrUserItem.attrName.length > 3 ? attrUserItem.attrName.length * 24 : 90"
                    show-overflow-tooltip
                  />
                </template>
              </template>
              <el-table-column
                prop="lockedName"
                label="锁定状态"
                width="80"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span :class="{'u-text-success': scope.row.locked ==='N', 'u-text-danger': scope.row.locked ==='Y'}">
                    {{ scope.row.lockedName }}
                  </span>
                </template>
              </el-table-column>
              <!-- <el-table-column
                prop="validName"
                label="有效标志"
                width="80"
                align="center"
                show-overflow-tooltip
              /> -->
              <el-table-column
                prop="enabled"
                label="操作"
                width="240"
                align="center"
                fixed="right"
              >
                <template
                  slot-scope="scope"
                >
                  <template v-if="scope.row.SFZZH==='N' || !scope.row.SFZZH">
                    <k-button
                      btn-text="编辑"
                      :auth-type="true"
                      type="primary"
                      plain
                      @click="handleEdit(scope.row)"
                    />
                    <k-button
                      btn-text="删除"
                      :auth-type="true"
                      type="danger"
                      plain
                      @click="handleDel(scope.row, scope.$index)"
                    />
                    <el-dropdown
                      type="primary"
                      trigger="click"
                      @command="(command)=>handleCommand(command, scope.row)"
                    >
                      <k-button
                        btn-text="更多操作"
                        :auth-type="true"
                        class="u-mg-l-10"
                        type="primary"
                        plain
                      >
                        <i class="el-icon-arrow-down" />
                      </k-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          command="reset"
                        >
                          重置密码
                        </el-dropdown-item>
                        <el-dropdown-item
                          command="unlock"
                        >
                          解锁
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                  <template v-else>
                    系统主账号
                  </template>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              class="c-page__pagination"
              :disabled="page.total<=0 || loading"
              :page-size="page.pageSize"
              :total="page.total"
              :current-page="page.pageNo"
              layout="total, sizes, prev, pager, next, jumper"
              :page-sizes="[10,15,20]"
              @current-change="search"
              @size-change="handleSizeChange"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 页面主内容：查询列表 End -->
    <!-- 修改 -->
    <add-dialog
      v-if=" showDialogName === 'add'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="refreshSearch()"
    />

    <!-- 修改 -->
    <edit-dialog
      v-if="showDialogName === 'edit'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="refreshSearch()"
    />

    <!-- 身份岗位关联组件 -->
    <relate-role-dialog
      v-if="showDialogName==='relateRole'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="handleSearchCapacity"
    />

    <!-- 身份权限部门关联组件 -->
    <relate-permission-dept-dialog
      v-if="showDialogName==='relatePermissionDept'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="handleSearchCapacity"
    />

    <!-- 切换组织组件 -->
    <change-dept-dialog
      v-if="showDialogName==='changeDept'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="search"
    />

    <!-- 消息确认 -->
    <operator-view-dialog
      v-if="showDialogName==='showTbResult'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="search"
    />
  </div>
</template>

<script>
import { userService } from './user.service.js';
import User from '@/features/system/attr/user/index.vue';

export default {
  name: 'XfUserManage',
  extends: User,
  components: {
    relateRoleDialog: () => import('./capacity/relateRoleDialog'),
    relatePermissionDeptDialog: () => import('./capacity/relatePermissionDeptDialog'),
    changeDeptDialog: () => import('./changeDeptDialog'),
    editDialog: () => import('./editDialog'),
    addDialog: () => import('./addDialog'),
    OperatorViewDialog: () => import('./viewTbDialog.vue')
  },
  data () {
    return {

      /* 分页实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      }
      /* 查询结果 End */
    };
  },
  computed: {
    /* 根据模态框类型动态展示标题 */
    zyjgzsType () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.IFF_USER_ZYJGZS) {
        return enums.IFF_USER_ZYJGZS;
      }
      return {};
    }

  },
  methods: {
    handleDialog (_name, _params) {
      this.showDialogName = _name;
      this.dialogParams = _params;
    },
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @param {*}
     * @return {*}
     */
    refreshSearch () {
      this.selectedRow.userCode = null;
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      this.trueFilterParams.deptCode = this.currentDeptCode;
      this.search();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      this.loading = true;
      // 单身份查询不同接口
      userService.query(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);
          // 职业资格证书类型 名称赋值
          this.page.rows.forEach(e => {
            for (const val in this.zyjgzsType) {
              if (this.zyjgzsType[val].id === e.ZGZSDJ) { e.ZGZSDJ_NAME = this.zyjgzsType[val].text; break; };
            }
          });

          // 移除单选按钮选中行
          // this.selectedRow = {};

          this.$nextTick(() => {
            this.$refs.attrUserTable.doLayout();
          });
        })
        .catch(err => {
          console.error('查询用户出错', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 新增用户
     * @param {*}
     * @return {*}
     */
    handleAddUser () {
      if (!this.currentDeptCode) {
        this.$alert('请选择机构部门！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        });

        return;
      }
      this.showDialogName = 'add';
      this.$route.params.userCode = null;
      this.$route.params.deptCode = this.currentDeptCode;
    },
    /**
     * 绑定广东社会平台
     */
    handleBindGdshpt () {
      const _this = this;
      _this.$confirm('是否确认将操作员信息推送至广东社会平台？', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        userService.bindGdshpt(this.currentDeptCode)
          .then(rsp => {
            if (rsp.data.length > 0) {
              this.handleDialog('showTbResult', { userList: rsp.data });
              this.refreshSearch();
            } else {
              this.$alert('暂无操作员需关联广东社会平台！', '提示', {
                confirmButtonText: '确定',
                type: 'warning',
                callback: action => {
                }
              });
            }
          })
          .catch(err => {
            console.error('绑定保存出错', err);
          })
          .finally(() => {
            this.loading = false;
          });
      })
        .catch(err => {
          console.error('推送错误！', err);
        })
        .finally(() => {
          _this.loading = false;
        });
    },
    /**
     * @description: 用户修改
     * @param {Object} 当前选中行的用户数据
     */
    handleEdit (_rowData) {
      if (_rowData.sourceType === '1') {
        this.$alert('当前用户信息数据来源为“同步”，不能修改用户信息', '提示', {
          confirmButtonText: '确定',
          type: 'error',
          callback: action => {
          }
        });
        return;
      }
      this.showDialogName = 'edit';

      this.$route.params.userCode = _rowData.userCode;
      // // 单身份版修改用户
      // this.openNavTab({ name: 'xfEditUser', params: { userCode: _rowData.userCode } });
    },
    handleCommand (command, row) {
      switch (command) {
        // 重置密码
        case 'reset':
          this.handleResetPwd(row);
          break;

        // 用户解锁
        case 'unlock':
          if (row.locked === 'Y') { this.handleUnlock(row); }
          break;

        default:
          break;
      }
    }
  },
  created () {
    console.log(this.zyjgzsType);
    const currentUser = this.$HMStoreService.getUserinfo();
    this.currentDeptCode = currentUser.capacity.deptCode;
    this.currentDeptName = currentUser.capacity.deptName;
    this.refreshSearch();
  }

};
</script>
